import { useFormContext } from '@calendly/form';
import { FullStoryExclude, FullStoryMask } from '@calendly/ui/components/fullstory-privacy';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { kebabCase } from 'lodash-es';
import { forwardRef } from 'react';
import { useSelector } from 'react-redux';
import { useGetUserQuery } from 'common';
import { getMemberName } from 'components/event_type_edit';
import { Layout } from 'components/layout';
import { useEventTypeContext } from 'features/event_type_provider';
import { isAdminOrOwnerOrGroupAdminSelector } from 'selectors/current_user';
import { useETEditorFormikPoolingType } from 'services/event_types';
import { HostPriority } from './host_priority';
import { ListItemActions, StyledUserInfoAvatar } from '../styles';
const TextContainer = props => <Layout direction="column" align="start" {...props} />;
const hostWrapperIsLockedCss = "h18dltb9";
const hostWrapperCss = "hwu7de0";
const HostWrapper = forwardRef((props, ref) => {
  const {
    isLocked,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(hostWrapperCss, {
    [hostWrapperIsLockedCss]: isLocked
  }, props.className)} />;
});
const hostDetailsIsMultiHostCss = "h1dfiwhx";
const hostDetailsCss = "h1291awt";
const HostDetails = forwardRef((props, ref) => {
  const {
    isMultiHost,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(hostDetailsCss, {
    [hostDetailsIsMultiHostCss]: isMultiHost
  }, props.className)} />;
});
export const HostListItem = ({
  member,
  isMultiHost,
  userPool,
  removeActionComponent,
  isLocked
}) => {
  const {
    eventType,
    isCreation
  } = useEventTypeContext();
  const isAdminOrOwnerOrGroupAdmin = useSelector(isAdminOrOwnerOrGroupAdminSelector);
  const {
    data: currentUser
  } = useGetUserQuery();
  const {
    isSubmitting
  } = useFormContext();
  const {
    isRoundRobin,
    isCollectiveRoundRobin
  } = useETEditorFormikPoolingType();
  const {
    isTeam,
    isGroup
  } = eventType;
  const canSelectHost = !isLocked && (isCreation && isAdminOrOwnerOrGroupAdmin || isTeam && isGroup);
  const canDelete = canSelectHost || !isLocked && isMultiHost;
  const canViewPriority = isMultiHost && (isRoundRobin || isCollectiveRoundRobin);
  const showActions = canDelete || canViewPriority;
  const isPending = member.is_pending;
  return <HostWrapper id={`${kebabCase(member.name)}-display`} isLocked={isLocked}>
      <HostDetails isMultiHost={isMultiHost}>
        <FullStoryExclude>
          <StyledUserInfoAvatar spaceless isNonInteractive size="x-small" isPendingUser={isPending} letter={member.avatar_letter} name={member.name} src={member.avatar_url} uuid={isPending ? member.organization_invitation_uuid : member.user_uuid} />
        </FullStoryExclude>
        <TextContainer>
          <BodyText weight="semibold"><FullStoryMask>{getMemberName(member, currentUser)}</FullStoryMask></BodyText>
          <BodyText size="small" color="muted"><FullStoryMask>{member.email}</FullStoryMask></BodyText>
        </TextContainer>
      </HostDetails>
      {showActions && <ListItemActions>
          {canViewPriority && <HostPriority disabled={isSubmitting || !member.enabled} member={member} userPool={userPool} isLocked={isLocked} />}
          {canDelete && removeActionComponent}
        </ListItemActions>}
    </HostWrapper>;
};

require("./host_list_item.wyw-in-js.css!=!../../../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./host_list_item.js");